export default __webpack_public_path__ + "static/media/paypal.5a3d1f1b.svg";